import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrows-left",
  "use": "icon-arrows-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrows-left\"><path d=\"M676.964 883.17L308.74 509.054 682.856 140.83c11.783-11.783 11.783-29.458 0-41.241-11.783-11.783-29.458-11.783-41.241 0L246.879 488.434c-11.784 11.783-11.784 29.458 0 41.24l388.844 394.737c11.784 11.783 29.458 11.783 41.241 0 11.784-11.783 11.784-29.458 0-41.241z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrows-left.svg
// module id = dp53
// module chunks = 65